import {customAxiosBE} from "../config";

export async function getAllTrafficTypeAPI() {
    return customAxiosBE.get(`/trafficType`)
}
